// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"sq","imageWrapper":"sr","image":"ss","imageInCenter":"st","ctaWrapper":"su","copyright":"sv","rentalBadge":"sw","sideGradient":"sx","bottomGradient":"sy"};